module.exports = __webpack_public_path__ + "img/atj.fe9197a2.jpg";